module.exports = __webpack_public_path__ + "img/Verso.4705a547.png";